import { render, staticRenderFns } from "./detileTanah.vue?vue&type=template&id=14bfbdb6&scoped=true&"
import script from "./detileTanah.vue?vue&type=script&lang=js&"
export * from "./detileTanah.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14bfbdb6",
  null
  
)

export default component.exports